query getCompanyEmailFunnelsStatistics($isMasterView: Boolean, $childCompanyId: ID) {
  companyEmailFunnelsStatistics: getCompanyEmailFunnelsStatistics(isMasterView: $isMasterView, childCompanyId: $childCompanyId) {
    sent
    uniqueOpens
    uniqueLinksClicked
  }
}
